import React from 'react'
import HtmlEditor from './components/HtmlEditor'
import HtmlPreview from './components/HtmlPreview'
import useHtmlModule from './hooks/useHtmlModule'

export default function HtmlModule({ name, isPreview = false, data, isCurrentThemeLight }) {
  const htmlModule = !isPreview ? useHtmlModule(name) : null

  if (isPreview && data) {
    return <HtmlPreview data={data} isCurrentThemeLight={isCurrentThemeLight} />
  }

  if (!htmlModule) {
    return null
  }

  return (
    <HtmlEditor
      name={name}
      isCurrentThemeLight={isCurrentThemeLight}
      dataError={htmlModule.dataError}
      handleDataChange={htmlModule.handleDataChange}
      MAX_DATA_LENGTH={htmlModule.MAX_DATA_LENGTH}
    />
  )
}
